import React, {useMemo} from 'react';
import {OrdinalColumn} from "./ReactTable";
import {ButtonLink, PageHeader} from "./Components";
import AddEditLocation from "./modals/AddEditLocation";
import DeleteLocation from "./modals/DeleteLocation";
import {RouteComponentProps} from "react-router-dom";
import type {LocationWebInfo} from "../services/API";
import {DataAPI} from "../services/API";
import {Helmet} from "react-helmet";
import ReactQueryTable from "./ReactQueryTable";

const LocationsTab = (props: RouteComponentProps) => {

  const columns = useMemo(()=>[
      OrdinalColumn,
      { Header: 'Nazwa', accessor: 'name' },
      { Header: 'Ścieżka', accessor: 'path', disableSortBy: true},
      { Header: 'Akcje',
        id: 'actions',
        Cell: ({ row }) => {
          const lwi: LocationWebInfo = row.original;
          return <div className="actions action-icons">
            <ButtonLink size="sm" variant="link" to={AddEditLocation.buildUrl(lwi.id)} withBackground={true} className="action-icon-btn action-edit">
              <i className="fas fa-pen"/>
              <span>Edytuj</span>
            </ButtonLink>
            <ButtonLink size="sm" variant="link" to={DeleteLocation.buildUrl(lwi.id)} withBackground={true} className="action-icon-btn action-delete">
              <i className="fas fa-trash"/>
              <span>Usuń</span>
            </ButtonLink>
          </div>
        }, disableSortBy: true
      }
    ], []);

    return <>
      <Helmet>
        <title>Lokacje</title>
      </Helmet>
      <PageHeader /* title="Lokacje" */>
        <ButtonLink variant="success" to={AddEditLocation.buildUrl('new')} withBackground={true}>
          <i className="fas fa-plus"/> Dodaj lokację
        </ButtonLink>
      </PageHeader>
      <ReactQueryTable type="location" queryKey="location-list" listenType="location" columns={columns} queryFunction={DataAPI.getLocationList}/>
    </>;
}

LocationsTab.url = '/locations';

export default LocationsTab;